import React, { useEffect } from 'react';
import classNames from 'classnames';
import GlobalCtx, { defaultGlobalCtx, defaultEmptyImage } from '@components/globalContext';
import { Image, Import, Header, Footer, Notice } from '@components';
import { Image as ImageUtil } from '@utils';
import { App as AppType, Image as ImageType, Samples } from '@types';

const App = (): JSX.Element => {
  const [app, setApp] = React.useState<AppType>(defaultGlobalCtx.app);
  const [image, setImage] = React.useState<ImageType>(defaultGlobalCtx.image);
  const [samples, setSamples] = React.useState<Samples>(defaultGlobalCtx.samples);
  const [imageExists, setImageExists] = React.useState<boolean>(ImageUtil.exists(image));

  const defaultCtx = {
    app,
    setApp,
    image,
    setImage,
    samples,
    setSamples,
  };

  useEffect(() => {
    if (!imageExists) {
      return;
    }

    if (!ImageUtil.canLoadAllImages(image)) {
      setImage({ ...defaultEmptyImage });
    }
  }, []);

  useEffect(() => {
    setImageExists(ImageUtil.exists(image));
  }, [image]);

  return (
    <GlobalCtx.Provider value={defaultCtx}>
      <div className={classNames('app min-h-screen', 'bg-sky-500 bg-gradient-to-r from-sky-700')}>
        <div className="min-h-screen xl:min-h-[80vh] flex xl:place-items-center justify-center">
          <div>
            <Notice />
            <Header />
            <main className="p-2 px-4">{imageExists ? <Image /> : <Import />}</main>
          </div>
        </div>
        <Footer />
      </div>
    </GlobalCtx.Provider>
  );
};

export default App;
